export const HOME_ASSET_BASE = 'https://static.cdn.oppenlab.com/oppenhome/';

export function oppenhomeAsset(path) {
  return `${HOME_ASSET_BASE}${path.replace(/^\/+/, '')}`;
}

const config = {
  videos: [
    oppenhomeAsset('landingPage/Mammut.mp4'),
    oppenhomeAsset('landingPage/Gugong.mp4'),
    oppenhomeAsset('landingPage/TUMI.mp4'),
    oppenhomeAsset('landingPage/Milwaukee.mp4'),
  ],
  iframe: 'https://holodeck.oppenlab.com/decks/be78b9bd-07f5-4cb4-8b3c-ff36f8a1ee61/ce757659-0161-40e5-ac25-b84ce124085f',
};

export default config;
